import React, { useEffect, useState } from "react";
import Input from "../../components/common/FormFields/input";
import Button from "../../components/common/button";
import AuthLayout from "../authLayout";
import {
  CloseEyeIcon,
  OpenEyeIcon,
  TickIcon,
} from "../../assets/images/svg/svg";
import { useForm } from "react-hook-form";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { home, profile, signUp } from "../../utils/router/constant";
import Radio from "../../components/common/FormFields/radio";
import api from "../../utils/interface";
import { toast } from "react-toastify";
import {
  clearExistingToken,
  getCodeFromUrl,
  getRedirectParams,
} from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { setIsFirstLogin, setLoading } from "../../store/slices/commonSlice";
import Loader from "../../components/common/loader";
import AgDetail from "../authLayout/agDetail";
import Checkbox from "../../components/common/FormFields/checkbox";

const SignIn = () => {
  const navigate = useNavigate();
  const [authMethod, setAuthMethod] = useState("otp");
  const [otpButtonClicked, setOtpButtonClicked] = useState(false);
  const [showPasswrd, setShowPassword] = useState(false);
  const loading = useSelector((state) => state.common.loading);
  const dispatch = useDispatch();
  const agDetails = useSelector((state) => state.common.agDetails);

  const {
    control,
    getValues,
    resetField,
    handleSubmit,
    formState: { errors, isValid },
    watch,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      signinType: "otp",
      mobile: "",
      otp: "",
      password: "",
    },
  });

  const mobile = watch("mobile");
  const codeFromUrl = getCodeFromUrl();

  useEffect(() => {
    setOtpButtonClicked(false);
  }, [mobile]);

  const onRadioChange = (e) => {
    const value = e.target.value;
    resetField("otp");
    resetField("password");
    setAuthMethod(value);
  };

  const sendOTPSuffix = () => {
    return authMethod === "otp" ? (
      <button
        className={`send--otp 
          ${otpButtonClicked ? "send--otp__clicked" : ""} 
          ${
            !otpButtonClicked && !errors.mobile && getValues("mobile")
              ? "send--otp__active"
              : ""
          }
        `.trim()}
        type="button"
        onClick={() => (otpButtonClicked ? null : handleSendOtp())}
      >
        {otpButtonClicked ? <TickIcon /> : ""} SEND OTP
      </button>
    ) : null;
  };

  const passwordSuffix = () => {
    return (
      <button
        className="send--otp"
        type="button"
        onClick={() => setShowPassword(!showPasswrd)}
      >
        {showPasswrd ? <CloseEyeIcon /> : <OpenEyeIcon />}
      </button>
    );
  };

  const handleSendOtp = async () => {
    const fd = new FormData();
    const mobile = getValues("mobile");
    const fromAction = "signin";

    fd.append("mobile", mobile);
    fd.append("fromAction", fromAction);
    fd.append("baseUrl", codeFromUrl);

    try {
      api
        .post(`/agsp/useraccount/sendOTP`, fd)
        .then((response) => {
          !otpButtonClicked && setOtpButtonClicked(true);
          toast.success("OTP sent successfully");
        })
        .catch((err) => {
          toast.error(err.response.data.error_message);
        });
    } catch (error) {
      console.error(
        "Error fetching data",
        error.response ? error.response.data : error.message
      );
    }
  };

  const handleSignin = async (data) => {
    dispatch(setLoading(true));
    clearExistingToken();
    let url = "";
    const fd = new FormData();
    fd.append("mobile", data.mobile);
    if (authMethod === "otp") {
      url = `/agsp/useraccount/verifyOTP`;
      fd.append("OTP", data.otp);
      fd.append("from_action", "signin");
      fd.append("baseUrl", codeFromUrl);
    } else {
      url = `/agsp/useraccount/authenticateByMobile`;
      fd.append("password", data.password);
      fd.append("isCustomer", 1);
      fd.append("baseUrl", codeFromUrl);
    }
    try {
      // api
      //   .post(url, fd)
      //   .then((response) => {
      //     if (response.data.jwt) {
      //       localStorage.setItem("token", response.data.jwt);
      //       dispatch(setLoading(false));
      //       dispatch(setIsFirstLogin(response.data.isFirstLogin));
      //       // setTimeout(() => {
      //       const dynamicValue = "ima";
      //       if (isFirstLogin === "1") {
      //         navigate(profile);
      //       } else {
      //         toast.success("Successfully Logged In");
      //         navigate(home);
      //       }
      //       // }, 3000);
      //     }
      //   })
      //   .catch((err) => {
      //     toast.error(err.response.data.error_message);
      //     store.dispatch(setLoading(false));
      //   });
      const response = await api.post(url, fd);
      if (response.data.jwt) {
        localStorage.setItem("token", response.data.jwt);
        dispatch(setLoading(false));
        dispatch(setIsFirstLogin(response.data.isFirstLogin));
        // navigate(home);
        // if (response.data.isFirstLogin === 1) {
        //   // toast.success("Welcome");
        //   navigate(profile);
        // } else {
        const isRedirected = getRedirectParams(navigate);

        if (!isRedirected) {
          navigate(home);
          // if (response.data.isFirstLogin === 1) {
          //   navigate(profile);
          // } else {
          //   navigate(home);
          // }
          // toast.success("Successfully Logged In");
        }
        // }
      }
    } catch (error) {
      toast.error(error.response.data.error_message);
      dispatch(setLoading(false));
    }
  };

  return (
    <AuthLayout>
      <div className="auth--form--wrapper">
        <AgDetail />
        <h1 className="auth--title">Welcome! Sign In into your account</h1>
        <p className="auth--subtitle">
          Sign In to manage your insurance policies with ease
        </p>
        <form
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit(handleSignin)}
        >
          <div className="auth--form">
            <Input
              type="tel"
              placeholder="Mobile Number"
              name="mobile"
              rules={{
                required: {
                  value: true,
                  message: "Required field",
                },
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Invalid Mobile Number",
                },
                minLength: {
                  value: 10,
                  message: "Minimum length should be 10",
                },
                maxLength: {
                  value: 10,
                  message: "Maximum length should not exceed 10",
                },
              }}
              control={control}
              errors={errors}
              suffix={sendOTPSuffix}
              // inputMode="numeric"
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
              }}
              // disabled={otpButtonClicked}
              maxLength={10}
              minLength={10}
            />
            {authMethod === "otp" ? (
              <Input
                type="tel"
                placeholder="OTP"
                name="otp"
                rules={{
                  required: {
                    value: true,
                    message: "Required field",
                  },
                  pattern: {
                    value: /^\d+$/,
                    message: "Invalid OTP",
                  },
                  minLength: {
                    value: 4,
                    message: "Minimum length should be 4",
                  },
                  maxLength: {
                    value: 4,
                    message: "Maximum length should not exceed 4",
                  },
                }}
                control={control}
                errors={errors}
                // inputMode="numeric"
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
                }}
                maxLength={4}
                minLength={4}
              />
            ) : (
              <Input
                type={showPasswrd ? "text" : "password"}
                placeholder="Password"
                name="password"
                rules={{
                  required: {
                    value: true,
                    message: "Required field",
                  },
                }}
                control={control}
                errors={errors}
                suffix={passwordSuffix}
              />
            )}
            <div className="radio--wrapper">
              <Radio
                label="OTP"
                name="signinType"
                value="otp"
                rules={{
                  required: {
                    value: true,
                    message: "Required field",
                  },
                }}
                control={control}
                errors={errors}
                checked={authMethod === "otp"}
                onInputChange={onRadioChange}
                className="radio-style"
              />
              <Radio
                label="Password"
                name="signinType"
                value="password"
                rules={{
                  required: {
                    value: true,
                    message: "Required field",
                  },
                }}
                control={control}
                errors={errors}
                checked={authMethod === "password"}
                onInputChange={onRadioChange}
                className="radio-style"
              />
            </div>
            {loading ? (
              <Loader />
            ) : (
              <Button
                type="submit"
                variant="primary"
                label="Sign In"
                disabled={!isValid}
              />
            )}
          </div>
        </form>
        {agDetails.signup_enabled ? (
          <>
          <div className="or--wrapper">
          <div className="line"></div>
          <span className="or--wrapper--text">or</span>
          <div className="line"></div>
        </div>
        <Button
          onClick={() => navigate(signUp)}
          type="button"
          variant="outlined"
          label="Sign Up"
        />
        {/* <div className="checkbox--wrapper">
          <Checkbox
            // label="I agree to the Terms and Conditions"
            rules={{
              required: true,
            }}
            name="terms"
            className="checkbox-style"
            control={control}
            errors={errors}
            options={[{ name: "I agree to the Terms and Conditions" }]}
          />
        </div> */}
      </>
        ) : (
          <></>
        )}
      </div>
    </AuthLayout>
  );
};

export default SignIn;
